module.exports = __webpack_public_path__ + "img/flowWisdomWhite.0ede9abb.png";